import {GET} from "../util";

const companyUrl = "api/company/";

const getCompanyUrl = id => {
    return `${companyUrl}${id}`;
};

const companyApi = {
    CompanyInfo: (companyId) => {
        const realUrl = getCompanyUrl(companyId);
        return GET(realUrl);
    }
};
export {
    companyApi
};